export const blockIconsFileFileUpload = (
	<span className='material-symbols-outlined'>file_upload</span>
);
